import { useSelector } from "react-redux";
import { useMemo } from "react";
import { selectEntitiesByFilters } from "../../../../../shared/store/views/entityView";
import { courseFiltersByNmmId } from "../../../../../shared/utils/entitiesFiltersUtils";
import AddStudyGroupFromNmm from "../addStudyGroupFromNmm/AddStudyGroupFromNmm.js/AddStudyGroupFromNmm";
import MyCourseItemWithOptions from "../../../../../shared/components/features/courseItem/myCourseItem/myCourseItemWithOptions/MyCourseItemWithOptions";
import iconsList from "../../../../../shared/components/ui/icons/iconsList";
import Widget from "../../../../../shared/components/features/widget/Widget";
import SectionList from "../../../../../shared/components/pages/myLearningPage/myLearningDomainPage/SectionList/SectionList";
import classes from "./CoursesNmmWidget.module.css";

const CoursesNmmWidget = ({ studyGroupId }) => {

    const { texts } = useSelector(state => state.translate);
    const filters = useMemo(() => courseFiltersByNmmId(studyGroupId), [studyGroupId]);
    const courses = useSelector(state => selectEntitiesByFilters(state, filters));

    return (
        <Widget
            icon={iconsList.myLearning}
            color="#FDDB71"
            title={texts.environmentsLearning}
            className={classes.CoursesAndAssessmentsWidget}
        >
            <div className={classes.WidgetContent}>
                <div className={classes.EnvironmentsSection}>
                    <SectionList
                        titel={texts.environments}
                        classNameList={classes.CoursesList}
                        ItemComponent={MyCourseItemWithOptions}
                        list={courses}
                        itemPropName={"course"}
                        AddItemComponent={AddStudyGroupFromNmm}
                    />
                </div>
            </div>
        </Widget>
    );
};

export default CoursesNmmWidget;